import React, { useState } from 'react'

import FirebaseContext from '../contexts/firebaseContext'
import firebase, { db, auth, storage } from '../utils/firebase'
import uuidv4 from '../utils/uuidv4'
import { apiGetAllTracks } from '../api/firestore'

import {
    getLang,
    saveLang,
    setNewTipsLangCollection,
    checkIfLangCollectionExists,
} from './Languages/FirebaseHelpers'
import {
    getTipsLangs,
    saveTipsToDb,
    getTipsFromDb,
} from './Tips/FirebaseHelpers'
import {
    getInitialUsersFromDb,
    getNextUsersFromDb,
    disableUserAtList,
    updateCurrentUser,
    searchInitialUsersAtDb,
    searchNextUsersFromDb,
    restoreUserAtList,
    createUserAtDb,
    resetPasswordRequest,
    updateUserRepresent,
} from './Users/FirebaseHelpers'
import {
    saveAutoTracksToDb,
    getAutoTracksFromDb,
} from './AutoStreamTracks/FirebaseHelpers'
import {
    checkForPlanetsUpdatesAtDb,
    checkForTracksUpdatesAtDb,
    addTrackToDb,
    addPlanetToDb,
    updatePlanetAtDb,
    updateTrackAtDb,
    deleteTrackAtDb,
    getHistoryFromDb,
    updateHistoryAtDb,
    getLastAddedTrackFromDb,
    tracksMigrationAtDb,
} from './Planets/FirebaseHelpers'

export const storageRef = storage.ref()

function Fire({ children }) {
    const [users, setUsers] = useState([])
    const [lastUser, setLastUser] = useState({})
    const [shouldLoadNextUsers, setShouldLoadNextUsers] = useState(true)
    const [admins, setAdmins] = useState([])
    // const [streamPicture, setStreamPicture] = useState([])
    const [roles, setRoles] = useState({})
    const [planets, setPlanets] = useState([])
    const [tracks, setTracks] = useState({})
    const [errors, setErrors] = useState({})
    const [streams, setStreams] = useState([])
    const [streamPictures, setStreamPictures] = useState([])
    const [privateKeys, setPrivateKeys] = useState({})
    const [autoRecordPaths, setAutoRecordPaths] = useState({})
    const [messages, setMessages] = useState([])
    const [promocodes, setPromocodes] = useState([])
    const [fetchingState, setFetchingState] = useState({
        users: false,
        updateUser: false,
        planets: false,
        tracks: false,
        streams: false,
        promocodes: false,
        receipts: false,
        tips: false,
        languages: false,
        // streamPicture: false
    })
    let usersListener = () => {}
    let adminsListener = () => {}
    let planetsListener = () => {}
    let tracksListeners = {}
    let streamsListener = () => {}
    let streamsPicturesListener = () => {}
    let messagesListener = () => {}
    let promocodesListener = () => {}

    const startMessagesListener = (...props) => {
        console.log(props)
        usersListener = checkForMessagesUpdates(...props)
    }
    const closeMessagesListener = () => {
        messagesListener()
        messagesListener = () => {}
    }
    const startAdminsListener = () => {
        adminsListener = checkForAdminsUpdates()
    }
    const closeAdminsListener = () => {
        adminsListener()
        adminsListener = () => {}
    }
    const startPlanetListener = async () => {
        planetsListener = await checkForPlanetsUpdates()
    }
    const closePlanetListener = () => {
        planetsListener()
        planetsListener = () => {}
    }
    const startPromocodesListener = async () => {
        promocodesListener = await checkForPromocodesUpdates()
    }
    const closePromocodesListener = () => {
        promocodesListener()
        promocodesListener = () => {}
    }
    const startTracksListener = async (planetId, localeId) => {
        tracksListeners[planetId + localeId] = await checkForTracksUpdates(
            planetId,
            localeId
        )
    }
    const closeTracksListener = (planetId, localeId) => {
        if (typeof tracksListeners[planetId + localeId] !== 'function') return
        if (planetId === undefined || localeId === undefined) {
            Object.keys(tracksListeners).map((listener) => {
                listener()
                return undefined
            })
        }
        tracksListeners[planetId + localeId]()
        tracksListeners[planetId + localeId] = () => {}
    }
    const closeStreamsListener = () => {
        streamsListener()
        streamsListener = () => {}
    }
    const startStreamsListener = async () => {
        streamsListener = await checkForStreamsUpdates()
    }
    const closeStreamPicturesListener = () => {
        streamsPicturesListener()
        streamsPicturesListener = () => {}
    }
    const startStreamPicturesListener = async () => {
        streamsPicturesListener = await checkForStreamPicturesUpdates()
    }
    const getStreamPictureByDate = (date) => {
        const weekday = new Array(7)
        weekday[1] = 'monday'
        weekday[2] = 'tuesday'
        weekday[3] = 'wednesday'
        weekday[4] = 'thursday'
        weekday[5] = 'friday'
        weekday[6] = 'saturday'
        weekday[0] = 'sunday'
        const dateWeekday = weekday[date.toDate().getDay()]
        return (
            date &&
            streamPictures[dateWeekday] &&
            streamPictures[dateWeekday].pictureUrl
        )
    }
    const addTrack = (planetId, localeId, newTrack) =>
        addTrackToDb(planetId, localeId, newTrack)
    const addPlanet = (newPlanet) => addPlanetToDb(newPlanet)
    const updatePlanet = (id, updatedPlanetData) =>
        updatePlanetAtDb(id, updatedPlanetData, fetchingState, setFetchingState)

    const moveTrackFile = async (trackFileUrl, trackFileName) => {
        setFetchingState({
            ...fetchingState,
            tracks: true,
        })

        const storageId = uuidv4().substring(1, 6)

        const loadFile = firebase.functions().httpsCallable('loadFile')

        const uploadResult = await loadFile({
            fileUrl: trackFileUrl,
            fileName: `${storageId}.${trackFileName}`,
        }).catch((error) => {
            console.error({ moveTrackFile: error })
            return undefined
        })

        setFetchingState({
            ...fetchingState,
            tracks: false,
        })

        if (!uploadResult || !uploadResult.data || uploadResult.data.error) {
            console.error({ moveTrackFile: uploadResult })
            return undefined
        }

        if (uploadResult.data.fileUrl) {
            return uploadResult.data.fileUrl
        }

        return undefined
    }

    const uploadTrackFile = async (trackFile) => {
        setFetchingState({
            ...fetchingState,
            tracks: true,
        })

        const storageId = uuidv4()

        const fileRef = storageRef.child(`sounds/${storageId}`)
        const firebaseTrackUrl = await fileRef
            .put(trackFile)
            .then((doc) => fileRef.getDownloadURL().then((url) => url))

        return moveTrackFile(firebaseTrackUrl, trackFile.name)

        // const reader = new FileReader() //reads the binary data and encodes it as base64 data url
        // reader.readAsDataURL(trackFile)

        // const promise = new Promise((resolve, reject) => {
        //     reader.onloadend = async () => {
        //         const fileBase64 = reader.result

        //         const uploadFile = firebase
        //             .functions()
        //             .httpsCallable('uploadFile')

        //         const uploadResult = await uploadFile({
        //             fileBase64,
        //             fileName: trackFile.name,
        //         }).catch((error) => {
        //             console.error({ uploadFileError: error })
        //             reject()
        //             return
        //         })

        //         if (
        //             !uploadResult ||
        //             !uploadResult.data ||
        //             uploadResult.data.error
        //         ) {
        //             console.error({ uploadFileError: uploadResult })
        //             reject()
        //             return
        //         }

        //         if (uploadResult.data && uploadResult.data.fileUrl) {
        //             resolve(uploadResult.data.fileUrl)
        //         } else {
        //             console.error({ uploadFileError: uploadResult })
        //             reject()
        //         }
        //     }
        // })

        // return promise
        //     .catch(() => {
        //         return undefined
        //     })
        //     .finally(() =>
        //         setFetchingState({
        //             ...fetchingState,
        //             tracks: false,
        //         })
        //     )
    }

    const updateTrack = async (
        planetId,
        trackId,
        localeId,
        updatedTrackData,
        trackFileUrl,
        trackTimespan,
        nightTrackFileUrl,
        nightTrackTimespan
    ) =>
        updateTrackAtDb(
            planetId,
            trackId,
            localeId,
            updatedTrackData,
            trackFileUrl,
            trackTimespan,
            nightTrackFileUrl,
            nightTrackTimespan,
            fetchingState,
            setFetchingState
        )

    const deleteTrack = (planetId, localeId, trackId) =>
        deleteTrackAtDb(
            planetId,
            localeId,
            trackId,
            fetchingState,
            setFetchingState
        )

    const checkForMessagesUpdates = (start, end) => {
        setFetchingState({
            ...fetchingState,
            messages: true,
        })

        return db
            .collection('chat')
            .where('dateTime', '>', start)
            .where('dateTime', '<', end)
            .onSnapshot(
                (snapshot) => {
                    const newMessages = []
                    snapshot.forEach((doc) => {
                        const data = doc.data()
                        newMessages.push({
                            id: doc.id,
                            data: {
                                ...data,
                                dateTime: data.dateTime.toDate(),
                            },
                        })
                    })
                    setMessages(newMessages)

                    setFetchingState({
                        ...fetchingState,
                        messages: false,
                    })
                },
                (error) => {
                    setFetchingState({
                        ...fetchingState,
                        messages: false,
                    })
                    setErrors({
                        ...errors,
                        messages: 'Ошибка доступа к базе',
                    })
                }
            )
    }
    const updateMessage = (id, updatedComment) => {
        setFetchingState({
            ...fetchingState,
            messages: true,
        })
        return db
            .doc(`chat/${id}`)
            .update(updatedComment)
            .then((doc) => ({
                error: false,
                message: 'Сообщение успешно обновлено',
            }))
            .catch((error) => ({
                error: true,
                message: 'Произошла ошибка при обновлении сообщения',
            }))
            .finally(() => {
                setFetchingState({
                    ...fetchingState,
                    messages: false,
                })
            })
    }
    const updateOldMessages = (locale = 'ru') => {
        setFetchingState({
            ...fetchingState,
            messages: true,
        })
        return db
            .collection('chat')
            .orderBy('dateTime', 'asc')
            .get()
            .then((snapshot) => {
                snapshot.forEach((doc) => {
                    if (!doc.data().locale) {
                        doc.ref.update({ locale })
                    }
                })
            })
            .finally(() => {
                setFetchingState({
                    ...fetchingState,
                    messages: false,
                })
            })

        // .doc(`chat/${id}`)
        // .update(updatedComment)
        // .then((doc) => ({
        //     error: false,
        //     message: 'Сообщение успешно обновлено',
        // }))
        // .catch((error) => ({
        //     error: true,
        //     message: 'Произошла ошибка при обновлении сообщения',
        // }))
        // .finally(() => {
        //     setFetchingState({
        //         ...fetchingState,
        //         messages: false,
        //     })
        // })
    }

    const createMessage = (newMessage, locale = 'ru') => {
        setFetchingState({
            ...fetchingState,
            messages: true,
        })

        const avatarURL =
            'https://firebasestorage.googleapis.com/v0/b/my-energy-stream.appspot.com/o/static%2Fadmin_avatar.png?alt=media&token=0124cbf5-bfdd-4a5a-ab06-a0ad2036e7b9'

        newMessage = {
            ...newMessage,
            userId: auth().currentUser.uid,
            userName: 'Администрация',
            photoURL: avatarURL,
            locale,
            dateTime: firebase.firestore.Timestamp.fromDate(new Date()),
        }

        return db
            .collection('chat')
            .add(newMessage)
            .then((doc) => ({
                error: false,
                message: 'Сообщение успешно создано',
            }))
            .catch((error) => ({
                error: true,
                message: 'Произошла ошибка при создании сообщения',
            }))
            .finally(() => {
                setFetchingState({
                    ...fetchingState,
                    messages: false,
                })
            })
    }

    const deleteMessage = (id) => {
        setFetchingState({
            ...fetchingState,
            messages: true,
        })

        return db
            .doc(`chat/${id}`)
            .delete()
            .then((doc) => ({
                error: false,
                message: 'Сообщение успешно удалено',
            }))
            .catch((error) => ({
                error: true,
                message: 'Произошла ошибка при удалении сообщения',
            }))
            .finally(() => {
                setFetchingState({
                    ...fetchingState,
                    messages: false,
                })
            })
    }
    const checkForAdminsUpdates = () => {
        setFetchingState({
            ...fetchingState,
            updateUser: true,
        })

        return db
            .collection('users')
            .where('role', 'in', ['admin', 'streamer'])
            .onSnapshot(
                (snapshot) => {
                    const newAdmins = []
                    snapshot.forEach((doc) => {
                        const data = doc.data()
                        newAdmins.push({
                            id: doc.id,
                            data: {
                                ...data,
                                displayName: `${data.name || ''} ${
                                    data.surname || ''
                                }`,
                                phone: data.phone || '',
                                email: data.email || '',
                            },
                        })
                    })
                    setAdmins(newAdmins)

                    setFetchingState({
                        ...fetchingState,
                        updateUser: false,
                    })
                },
                (error) => {
                    setFetchingState({
                        ...fetchingState,
                        updateUser: false,
                    })
                    setErrors({
                        ...errors,
                        admins: 'Ошибка доступа к базе',
                    })
                }
            )
    }
    const updateStreamPicture = async (id, pictureFile) => {
        setFetchingState({
            ...fetchingState,
            streams: true,
        })

        const storageId = uuidv4()

        const fileRef = storageRef.child(`pictures/${storageId}`)
        if (pictureFile instanceof File) {
            return fileRef
                .put(pictureFile)
                .then(async (doc) => {
                    const pictureUrl = await fileRef
                        .getDownloadURL()
                        .then((url) => url)

                    return db
                        .doc(`streamPictures/${id}`)
                        .set({
                            pictureUrl,
                        })
                        .then((doc) => ({
                            error: false,
                            message: 'Картинка успешно обновлена',
                        }))
                })
                .catch(
                    (firebaseError) => (
                        {
                            error: true,
                            message: 'Произошла ошибка при обновлении картинки',
                        },
                        firebaseError
                    )
                )
                .finally(() =>
                    setFetchingState({
                        ...fetchingState,
                        streams: false,
                    })
                )
        }
    }
    const checkForStreamPicturesUpdates = () => {
        setFetchingState({
            ...fetchingState,
            streams: true,
        })
        return db.collection('streamPictures').onSnapshot(
            (snapshot) => {
                const newStreamPictures = {}
                snapshot.forEach((doc) => {
                    const data = doc.data()
                    try {
                        newStreamPictures[doc.id] = data
                    } catch (error) {}
                })
                setStreamPictures(newStreamPictures)

                setFetchingState({
                    ...fetchingState,
                    streams: false,
                })
            },
            (error) => {
                setFetchingState({
                    ...fetchingState,
                    streams: false,
                })
                setErrors({
                    ...errors,
                    streams: 'Ошибка доступа к базе',
                })
            }
        )
    }
    const checkForStreamsUpdates = () => {
        setFetchingState({
            ...fetchingState,
            streams: true,
        })

        return db.collection('streams').onSnapshot(
            (snapshot) => {
                const newStreams = []
                snapshot.forEach((doc) => {
                    const data = doc.data()
                    try {
                        newStreams.push({
                            ...data,
                            startDate: data.startDate.toDate(),
                            endDate: data.endDate.toDate(),
                            id: doc.id,
                            title: data.name,
                        })
                    } catch (error) {}
                })
                setStreams(newStreams)

                setFetchingState({
                    ...fetchingState,
                    streams: false,
                })
            },
            (error) => {
                setFetchingState({
                    ...fetchingState,
                    streams: false,
                })
                setErrors({
                    ...errors,
                    streams: 'Ошибка доступа к базе',
                })
            }
        )
    }
    const checkForPlanetsUpdates = () =>
        checkForPlanetsUpdatesAtDb(
            fetchingState,
            setFetchingState,
            setPlanets,
            errors,
            setErrors
        )
    const checkForTracksUpdates = (planetId, localeId) =>
        checkForTracksUpdatesAtDb(
            planetId,
            localeId,
            fetchingState,
            setFetchingState,
            tracks,
            setTracks,
            errors,
            setErrors
        )

    const updateRole = async (user, newRole) => {
        db.collection('roles')
            .doc(user.id)
            .update(newRole)
            .then(function () {
                return {
                    error: false,
                    message: 'Роль пользователя успешно обновлёна',
                }
            })
            .catch(function (error) {
                return {
                    error: true,
                    message:
                        'Произошла ошибка при обновлении роли пользователя',
                }
            })
    }

    const checkCollision = (targetStream) =>
        streams.some(
            (stream) =>
                (stream.startDate.getTime() <
                    targetStream.startDate.getTime() &&
                    stream.endDate.getTime() >
                        targetStream.startDate.getTime()) ||
                (stream.startDate.getTime() < targetStream.endDate.getTime() &&
                    stream.endDate.getTime() >
                        targetStream.endDate.getTime()) ||
                (stream.startDate.getTime() >
                    targetStream.startDate.getTime() &&
                    stream.endDate.getTime() < targetStream.endDate.getTime())
        )

    const updateStreamTranslations = async (streamId) => {
        const updateStreamTranslations = firebase
            .functions()
            .httpsCallable('updateStreamTranslations')

        return updateStreamTranslations({ streamId })
    }

    const addStream = async (newStream) => {
        try {
            setFetchingState({
                ...fetchingState,
                streams: true,
            })

            if (
                newStream.endDate.getTime() - newStream.startDate.getTime() >=
                86400000
            ) {
                setTimeout(() => {
                    setFetchingState({
                        ...fetchingState,
                        streams: false,
                    })
                }, 1000)
                return { error: true, message: 'Стрим слишком длинный' }
            }

            if (newStream.startDate.getTime() >= newStream.endDate.getTime()) {
                setTimeout(() => {
                    setFetchingState({
                        ...fetchingState,
                        streams: false,
                    })
                }, 1000)
                return {
                    error: true,
                    message:
                        'Некорректный формат даты начала или окончания стрима',
                }
            }

            if (checkCollision(newStream)) {
                setTimeout(() => {
                    setFetchingState({
                        ...fetchingState,
                        streams: false,
                    })
                }, 1000)
                return {
                    error: true,
                    message: 'Стримы не могут пересекаться',
                }
            }

            newStream.streamer = {
                uid: auth().currentUser.uid,
                name: auth().currentUser.displayName,
            }
            newStream.startDate = newStream.startDate.toISOString()
            newStream.endDate = newStream.endDate.toISOString()

            const createStream = firebase
                .functions()
                .httpsCallable('createStream')

            return createStream(newStream)
                .then((result) => result.data)
                .catch((error) => ({
                    error: true,
                    message: 'Произошла ошибка',
                    firebaseError: error,
                }))
                .finally(() =>
                    setFetchingState({
                        ...fetchingState,
                        streams: false,
                    })
                )
        } catch (error) {
            return Promise.reject({
                error: true,
                message: 'Произошла ошибка при добавлении стрима',
            })
        }
    }

    const getStreamKey = (streamId) => {
        return db
            .doc(`streams/${streamId}/privateKeys/privateKey`)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    const key = doc.data().key
                    const streamAutoRecordsPaths =
                        doc.data().streamAutoRecordsPaths

                    setPrivateKeys({
                        ...privateKeys,
                        [streamId]: key,
                    })
                    setAutoRecordPaths({
                        ...autoRecordPaths,
                        [streamId]: streamAutoRecordsPaths,
                    })

                    return { error: false, key: key }
                } else {
                    setPrivateKeys({
                        ...privateKeys,
                        [streamId]: null,
                    })
                }
                return { error: true, message: 'Ключ не найден' }
            })
            .catch((error) => ({
                error: true,
                message: 'Ошибка при получении ключа',
                firebaseError: error,
            }))
    }

    const saveAutoTracks = (autoRecords) =>
        saveAutoTracksToDb(autoRecords, fetchingState, setFetchingState)
    const getAutoTracks = () =>
        getAutoTracksFromDb(fetchingState, setFetchingState)

    const updateStream = async (streamId, updatedStream) => {
        if (
            updatedStream.endDate.getTime() -
                updatedStream.startDate.getTime() >=
            86400000
        ) {
            return { error: true, message: 'Стрим слишком длинный' }
        }

        if (
            updatedStream.startDate.getTime() >= updatedStream.endDate.getTime()
        ) {
            return {
                error: true,
                message: 'Некорректный формат даты начала или окончания стрима',
            }
        }

        if (checkCollision(updatedStream)) {
            return {
                error: true,
                message: 'Стримы не могут пересекаться',
            }
        }
        return db
            .doc(`streams/${streamId}`)
            .update(updatedStream)
            .then((doc) => ({
                error: false,
                message: 'Стрим успешно обновлен',
            }))
            .catch((error) => ({
                error: true,
                message: 'Произошла ошибка при обновлении стрима',
            }))
            .finally(() =>
                setFetchingState({
                    ...fetchingState,
                    streams: false,
                })
            )
    }

    const updateStreamAutoRecordsPaths = async (
        streamId,
        streamAutoRecordsPaths
    ) => {
        setFetchingState({ ...fetchingState, streams: true })
        const streamPrivateKey = await getStreamKey(streamId)

        if (!streamPrivateKey)
            return { error: true, message: 'Не найден приватный ключ стрима' }

        return db
            .doc(`streams/${streamId}/privateKeys/privateKey`)
            .update({ streamAutoRecordsPaths })
            .then((doc) => ({
                error: false,
                message: 'Стрим успешно обновлен',
            }))
            .catch((error) => ({
                error: true,
                message: 'Произошла ошибка при обновлении стрима',
            }))
    }

    const deleteStream = async (streamId) => {
        setFetchingState({
            ...fetchingState,
            streams: true,
        })
        return db
            .doc(`streams/${streamId}`)
            .delete()
            .then((doc) => ({ error: false, message: 'Стрим успешно удален' }))
            .catch((error) => ({
                error: true,
                message: 'Произошла ошибка при удалении стрима',
            }))
            .finally(() =>
                setFetchingState({
                    ...fetchingState,
                    streams: false,
                })
            )
    }

    const getInitialUsersList = (limit) =>
        getInitialUsersFromDb(
            limit,
            setUsers,
            setLastUser,
            setShouldLoadNextUsers,
            fetchingState,
            setFetchingState,
            errors,
            setErrors
        )

    const searchInitialUsers = (limit, queryText) =>
        searchInitialUsersAtDb(
            limit,
            queryText,
            setUsers,
            setLastUser,
            setShouldLoadNextUsers,
            fetchingState,
            setFetchingState,
            errors,
            setErrors
        )

    const updateAllUserRepresent = () =>
        updateUserRepresent(fetchingState, setFetchingState)

    const getNextUsersList = (limit, setIsNextUsersListLoading) =>
        getNextUsersFromDb(
            limit,
            setShouldLoadNextUsers,
            users,
            setUsers,
            lastUser,
            setLastUser,
            setIsNextUsersListLoading,
            errors,
            setErrors
        )

    const searchNextUsers = (limit, queryText, setIsNextUsersListLoading) =>
        searchNextUsersFromDb(
            limit,
            queryText,
            setShouldLoadNextUsers,
            users,
            setUsers,
            lastUser,
            setLastUser,
            setIsNextUsersListLoading,
            errors,
            setErrors
        )

    const createUser = async (user) =>
        await createUserAtDb(
            user,
            users,
            setShouldLoadNextUsers,
            setUsers,
            lastUser,
            setLastUser,
            fetchingState,
            setFetchingState,
            errors,
            setErrors
        )

    const updateUser = async (userId, updatedUser) =>
        await updateCurrentUser(
            userId,
            updatedUser,
            users,
            setUsers,
            fetchingState,
            setFetchingState
        )
    const disableUser = async (user) =>
        await disableUserAtList(
            user,
            users,
            setUsers,
            fetchingState,
            setFetchingState
        )
    const restoreUser = async (user) =>
        await restoreUserAtList(
            user,
            users,
            setUsers,
            fetchingState,
            setFetchingState
        )
    const resetPassword = (email) =>
        resetPasswordRequest(email, fetchingState, setFetchingState)

    const getHistory = (planetId) =>
        getHistoryFromDb(planetId, fetchingState, setFetchingState)
    const updateHistory = async (planetId, track, eventType, changedData) =>
        await updateHistoryAtDb(planetId, track, eventType, changedData)
    const getLastAddedTrack = (planetId, localeId) =>
        getLastAddedTrackFromDb(planetId, localeId)
    const tracksMigration = () => tracksMigrationAtDb()

    const getReceipts = (userId) => {
        setFetchingState({
            ...fetchingState,
            receipts: true,
        })
        return db
            .collection(`receipts/${userId}/receipts`)
            .get()
            .then((snapshot) => {
                const receipts = []
                snapshot.forEach((doc) => {
                    receipts.push({ id: doc.id, data: doc.data() })
                })
                return receipts
            })
            .finally(() =>
                setFetchingState({
                    ...fetchingState,
                    receipts: false,
                })
            )
    }

    const sendPushMessage = (
        topic,
        title,
        body,
        data = {},
        languageId = undefined
    ) => {
        setFetchingState({
            ...fetchingState,
            messages: true,
        })

        const sendMessageToTopic = firebase
            .functions()
            .httpsCallable('sendMessageToTopic')

        return sendMessageToTopic({
            topic,
            title,
            body,
            data,
            languageId,
        }).finally(() =>
            setFetchingState({
                ...fetchingState,
                messages: false,
            })
        )
    }

    const getTips = (tipsCollectionName) =>
        getTipsFromDb(
            tipsCollectionName,
            fetchingState,
            setFetchingState,
            errors,
            setErrors
        )
    const saveTips = (tips, tipsCollectionName) =>
        saveTipsToDb(
            tips,
            tipsCollectionName,
            fetchingState,
            setFetchingState,
            errors,
            setErrors
        )
    const getTipsLanguages = () =>
        getTipsLangs(fetchingState, setFetchingState, errors, setErrors)

    const getAllTracks = async () => {
        try {
            setFetchingState({
                ...fetchingState,
                tracks: true,
            })

            const tracks = await apiGetAllTracks()

            setTracks(tracks)
            console.log(tracks)
        } catch (error) {
            console.log(error)
        } finally {
            setFetchingState({
                ...fetchingState,
                tracks: false,
            })
        }
    }

    const updateCache = async () => {
        try {
            const updateCacheFire = firebase
                .functions()
                .httpsCallable('updateCache')

            await updateCacheFire()
            return { error: false }
        } catch (error) {
            console.log('updateCache: ', error)
            return { error: true }
        }
    }

    const checkForPromocodesUpdates = async () => {
        setFetchingState({
            ...fetchingState,
            promocodes: true,
        })

        return db.collection('promocodes').onSnapshot(
            (snapshot) => {
                const newPromocodes = []
                snapshot.forEach((doc) => {
                    newPromocodes.push({
                        id: doc.id,
                        data: doc.data(),
                    })
                })

                setPromocodes(newPromocodes)

                setFetchingState({
                    ...fetchingState,
                    promocodes: false,
                })
            },
            (error) => {
                setFetchingState({
                    ...fetchingState,
                    promocodes: false,
                })
                setErrors({
                    ...errors,
                    promocodes: 'Ошибка доступа к базе',
                })
            }
        )
    }

    const updatePromocode = async (promococdeId, updatedPromocode) => {
        setFetchingState({
            ...fetchingState,
            promocodes: true,
        })

        try {
            return await db
                .collection('promocodes')
                .doc(promococdeId)
                .update(updatedPromocode)
                .then(() => ({
                    error: false,
                    message: 'Промокод обновлён',
                }))
        } catch {
            return {
                error: true,
                message: 'Произошла ошибка, возможно проблемы с сервером',
            }
        } finally {
            setFetchingState({
                ...fetchingState,
                promocodes: false,
            })
        }
    }

    const createPromocode = async () => {
        setFetchingState({
            ...fetchingState,
            promocodes: true,
        })

        try {
            const createPromocodeFunction = firebase
                .functions()
                .httpsCallable('generateAdminPromocode')
            return await createPromocodeFunction().then(() => ({
                error: false,
                message: 'Промокод создан',
            }))
        } catch {
            return {
                error: true,
                message: 'Произошла ошибка, возможно проблемы с сервером',
            }
        } finally {
            setFetchingState({
                ...fetchingState,
                promocodes: false,
            })
        }
    }

    const saveLanguage = (language) =>
        saveLang(language, fetchingState, setFetchingState, errors, setErrors)
    const getLanguages = () =>
        getLang(fetchingState, setFetchingState, errors, setErrors)
    const checkIfLanguageCollectionExists = (language) =>
        checkIfLangCollectionExists(
            language,
            fetchingState,
            setFetchingState,
            errors,
            setErrors
        )
    const setNewTipsLanguageCollection = (language) =>
        setNewTipsLangCollection(
            language,
            fetchingState,
            setFetchingState,
            errors,
            setErrors
        )

    return (
        <FirebaseContext.Provider
            value={{
                data: {
                    users,
                    lastUser,
                    shouldLoadNextUsers,
                    roles,
                    planets,
                    fetchingState,
                    tracks,
                    errors,
                    streams,
                    admins,
                    privateKeys,
                    autoRecordPaths,
                    messages,
                    promocodes,
                    streamPictures,
                },
                changeData: {
                    setUsers,
                    setLastUser,
                    setShouldLoadNextUsers,
                    setAutoRecordPaths,
                    setFetchingState,
                },
                getInitialUsersList,
                getNextUsersList,
                searchInitialUsers,
                searchNextUsers,
                disableUser,
                updateUser,
                updateRole,
                restoreUser,
                createUser,
                resetPassword,
                getReceipts,
                updateAllUserRepresent,

                startAdminsListener,
                closeAdminsListener,

                startPlanetListener,
                closePlanetListener,
                addPlanet,
                updatePlanet,

                startTracksListener,
                closeTracksListener,
                addTrack,
                getLastAddedTrack,
                moveTrackFile,
                uploadTrackFile,
                updateTrack,
                deleteTrack,
                getAllTracks,

                startStreamsListener,
                closeStreamsListener,
                startStreamPicturesListener,
                closeStreamPicturesListener,
                updateStream,
                updateStreamAutoRecordsPaths,
                deleteStream,
                addStream,
                getStreamKey,
                checkForStreamPicturesUpdates,
                updateStreamPicture,
                updateStreamTranslations,
                getStreamPictureByDate,
                saveAutoTracks,
                getAutoTracks,

                startMessagesListener,
                closeMessagesListener,
                updateMessage,
                deleteMessage,
                createMessage,
                updateOldMessages,

                getHistory,
                updateHistory,
                updateCache,
                tracksMigration,

                startPromocodesListener,
                closePromocodesListener,
                updatePromocode,
                createPromocode,

                sendPushMessage,

                getTipsLanguages,
                getTips,
                saveTips,

                saveLanguage,
                checkIfLanguageCollectionExists,
                setNewTipsLanguageCollection,
                getLanguages,
            }}
        >
            {children}
        </FirebaseContext.Provider>
    )
}

export default Fire
